import React from 'react';

// import '@style/components/loading.scss';
import '../../styles/components/loading.scss';

function Loading({ isLoading = true, tip, className = '', ...props }) {
  const { style } = props;
  return (
    isLoading && (
      <div className="d-inline-block text-center" style={style}>
        <div className={`a-loading a-default ${className}`} />
        <div className="a-mt-10 a-h6 a-apply-theme-font-default-white">
          {tip || ''}
        </div>
      </div>
    )
  );
}

export default React.memo(Loading);
